var _effectorFileName = "/builds/gmini/front-common/src/forge-viewer/Components/ErrorBar.tsx";
import * as React from 'react';
import { styled, Snackbar as MuiSnackbar } from '@mui/material';
import SnackbarContent from '@mui/material/SnackbarContent';
import { Box } from '@gmini/ui-kit/lib/Box';
import { jsx as _jsx } from "react/jsx-runtime";
export var ErrorBar = /*#__PURE__*/React.memo(function (_ref) {
  var message = _ref.message,
      open = _ref.open,
      action = _ref.action;
  return /*#__PURE__*/_jsx(Box, {
    position: "absolute",
    zIndex: 2,
    children: /*#__PURE__*/_jsx(Snackbar, {
      open: !!open,
      anchorOrigin: {
        vertical: 'bottom',
        horizontal: 'center'
      },
      children: /*#__PURE__*/_jsx(ErrorContent, {
        message: message || '',
        action: action
      })
    })
  });
});
ErrorBar.displayName = 'ErrorBar';
var Snackbar = styled(MuiSnackbar)({
  width: '100%'
});
var ErrorContent = styled(SnackbarContent)({
  minWidth: 'auto',
  wordBreak: 'break-all',
  background: '#ce2424'
});